import React from 'react'
import { UnderlineNavigationTabs } from 'uiComponents/navigation/underlineNavigationTabs'
import { useProductDetailTabs } from 'products/productDetailTabsContext'

function ProductDetailHeadingTabs() {
    const { detailTabs } = useProductDetailTabs()

    if (!detailTabs) {
        return null
    }

    return <UnderlineNavigationTabs tabs={detailTabs} />
}

export default ProductDetailHeadingTabs
